module.exports = __webpack_public_path__ + "assets/img/tongdian3.16b28106.png";